import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sets a `data-route` attribute on <body> based on the current top-level route.
 * Used by index.css to apply page-specific colorful gradient titles.
 */
const RouteThemeTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const segment = pathname.split("/").filter(Boolean)[0] || "home";
    document.body.dataset.route = segment;
    return () => {
      // keep attribute; next route will overwrite
    };
  }, [pathname]);

  return null;
};

export default RouteThemeTracker;
